import {
	CreateAllocationTemplateMutation,
	DeleteAllocationTemplateMutation
} from "~/gql/mutations/restock/allocationTemplate.generated";
import { GetAllocationTemplatesQuery } from "~/gql/queries/restock/allocationTemplate.generated";

export const allocationTemplateEndpoints = {
	CreateAllocationTemplate: {
		invalidatesTags: ["AllocationTemplates"] as AddTagTypes,
		transformResponse: (res: CreateAllocationTemplateMutation) => res
	},
	DeleteAllocationTemplate: {
		invalidatesTags: ["AllocationTemplates"] as AddTagTypes,
		transformResponse: (res: DeleteAllocationTemplateMutation) => res
	},
	GetAllocationTemplates: {
		providesTags: ["AllocationTemplates"] as AddTagTypes,
		transformResponse: (res: GetAllocationTemplatesQuery) => res
	}
};
